import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { decrement, increment } from "../redux/slice/counterSlice";

const Footer = (props) => {
  // const count = useSelector((state) => state.counter.value);
  // const dispatch = useDispatch();
  return (
    <section className="footer">
      {/* <div>
        <div>
          <button
            aria-label="Increment value"
            onClick={() => dispatch(increment())}
          >
            Increment
          </button>
          <span>{count}</span>
          <button
            aria-label="Decrement value"
            onClick={() => dispatch(decrement())}
          >
            Decrement
          </button>
        </div>
      </div> */}
      <div className={props.first}>
        <p className="footerText">
          © All copyrights reserved by{" "}
          <span className="agrofarms">Latitude Geospatial</span> .
        </p>
      </div>
    </section>
  );
};

export default Footer;
